import { Card, CardBody, Col, Modal, ModalFooter } from "reactstrap";
import { Btn, H4, H5, Image, UL } from "../../AbstractElements";
import { dynamicImage } from "../../service";
import { ProfileModalType } from "../../types/modal/ModalTypes";
import { useTranslation } from "react-i18next";

const BlockModal: React.FC<ProfileModalType> = ({ modalOne, modalOneToggle, orgData,modalType}) => {
  
  const { t } = useTranslation();

  // set message for type of action

  const getModalMessage = () => {
    switch (modalType) {
      case "Block":
        return t("AreYouSureYouWantToBlock");
      case "Unblock":
        return t("AreYouSureYouWantToUnblock");
      case "Delete":
        return t("AreYouSureYouWantToDelete");
      default:
        return "";
    }
  };
// Confirmation Modal for Block Organization
  return (
    <Modal fade centered isOpen={modalOne} toggle={modalOneToggle} >
      <div className="modal-dialog m-0">
        <div className="modal-content">
          <Col xl="12">
            <Card className="social-profile mb-0">
              <CardBody>
                <div>
                  <Image
                    className="for-light"
                    src={dynamicImage(orgData?.image)}
                    alt="logo"
                    style={{
                      width: "100px",
                      height: "60px",
                      paddingLeft: "1rem",
                    }}
                  />
                </div>

                <div className="social-details">
                  <H5>{getModalMessage()} </H5>
                  <span> <H4>{orgData?.name}</H4></span>
                 
                  <UL className="social-follow simple-list flex-row">
                    <ModalFooter>
                      <Btn color="btn btn-danger" onClick={modalOneToggle}>
                        {t("Cancel")}
                      </Btn>
                      <Btn color="btn btn-success">{t("Confirm")}</Btn>
                    </ModalFooter>
                  </UL>
                </div>
              </CardBody>
            </Card>
          </Col>
        </div>
      </div>
    </Modal>
  );
};

export default BlockModal;
